import { DateStringCreator as dateStringCreator } from "@utils/DateStringCreator";
import { handleCustomUDL } from "@utils/UDLUtils";
import { isMainOrMiddleClick } from "@utils/MouseEventButton";

export class ArticleHead {
  private ctx: HTMLElement;
  private abortController = new AbortController();

  constructor(element: HTMLElement) {
    this.ctx = element;
  }

  init(): this {
    this.setPublicationDateString();
    this.setUDLListeners();
    return this;
  }

  private setPublicationDateString(): void {
    const publicationDateIso = this.ctx.dataset.publicationDateIso ?? "";
    const labelToday = this.ctx.dataset.labelToday ?? "";
    const labelDaysAgo = this.ctx.dataset.labelDaysAgo ?? "";
    const dateSpan = this.ctx.querySelector<HTMLElement>(".publication-date");

    const publicationDateString = dateStringCreator.createDateFromLabels(
      publicationDateIso,
      labelToday,
      labelDaysAgo,
    );

    if (dateSpan) {
      if (publicationDateString.length > 0) {
        dateSpan.textContent = publicationDateString;
      }
      dateSpan.style.display = "";
    }
  }

  private setUDLListeners(): void {
    const { signal } = this.abortController;
    const tag = this.ctx.querySelector<HTMLAnchorElement>(".meta-wrapper .meta .tag");
    const authors = this.ctx.querySelectorAll<HTMLAnchorElement>(".comp-author-list .mole-author");

    tag?.addEventListener("click", (e) => {
      if (!isMainOrMiddleClick(e)) return;
      handleCustomUDL("youtooth_detail_main_category_click", {
        link_text: tag.textContent ?? "",
        link_url: tag.href ?? "",
      });
    }, { signal });

    tag?.addEventListener("auxclick", (e) => {
      if (!isMainOrMiddleClick(e)) return;
      handleCustomUDL("youtooth_detail_main_category_click", {
        link_text: tag.textContent ?? "",
        link_url: tag.href ?? "",
      });
    }, { signal });

    authors.forEach((author) => {
      const authorName = author.querySelector<HTMLElement>(".name")?.textContent ?? "";
      const url = author.href ?? "";

      author.addEventListener("click", (e) => {
        if (!isMainOrMiddleClick(e)) return;
        handleCustomUDL("youtooth_detail_author_click", { link_text: authorName, link_url: url });
      }, { signal });

      author.addEventListener("auxclick", (e) => {
        if (!isMainOrMiddleClick(e)) return;
        handleCustomUDL("youtooth_detail_author_click", { link_text: authorName, link_url: url });
      }, { signal });
    });
  }

  destroy(): void {
    this.abortController.abort();
  }

  static initAll(): void {
    document
      .querySelectorAll<HTMLElement>('[data-component="article-head"]')
      .forEach((el) => new ArticleHead(el).init());
  }
}

